import { render, staticRenderFns } from "./webinar-company.vue?vue&type=template&id=2878de40&"
import script from "./webinar-company.vue?vue&type=script&lang=js&"
export * from "./webinar-company.vue?vue&type=script&lang=js&"
import style0 from "./webinar-company.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports